module.exports = __webpack_public_path__ + "static/media/en-cancel-service_4.9a852abe.png";